export default __webpack_public_path__ + "static/media/julia1.f6109c63.jpeg";